import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { logout } from "../redux/action/auth";

const SessionExpirationModal = ({ isOpen, onLogout }) => {
  const [countdown, setCountdown] = useState(30); // 30 seconds countdown
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            // Auto logout when countdown reaches 0
            handleLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, countdown]);

  // Reset countdown when modal opens
  useEffect(() => {
    if (isOpen) {
      setCountdown(30);
      setIsLoggingOut(false);
    }
  }, [isOpen]);

  const handleLogout = () => {
    setIsLoggingOut(true);
    if (onLogout) {
      onLogout();
    } else {
      dispatch(logout());
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <ModalHeader
        style={{
          backgroundColor: "#dc3545",
          color: "white",
          borderBottom: "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <i
            className="fas fa-exclamation-triangle"
            style={{ fontSize: "24px" }}
          ></i>
          <span>Session Expired</span>
        </div>
      </ModalHeader>
      <ModalBody style={{ padding: "30px", textAlign: "center" }}>
        <div style={{ marginBottom: "20px" }}>
          <i
            className="fas fa-clock"
            style={{
              fontSize: "60px",
              color: "#dc3545",
              marginBottom: "15px",
            }}
          ></i>
        </div>
        <h5 style={{ marginBottom: "15px", fontWeight: 600 }}>
          Your session has expired
        </h5>
        <p style={{ color: "#6c757d", marginBottom: "20px" }}>
          For security reasons, you have been logged out due to inactivity or an
          expired authentication token. Please login again to continue.
        </p>

        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "20px",
          }}
        >
          <div
            style={{ fontSize: "48px", fontWeight: "bold", color: "#dc3545" }}
          >
            {countdown}
          </div>
          <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
            {countdown > 0
              ? `Automatically logging out in ${countdown} second${countdown !== 1 ? "s" : ""}...`
              : "Logging out now..."}
          </div>
        </div>
      </ModalBody>
      <ModalFooter
        style={{
          justifyContent: "center",
          borderTop: "1px solid #dee2e6",
          padding: "20px",
        }}
      >
        <Button
          color="danger"
          onClick={handleLogout}
          disabled={isLoggingOut}
          style={{
            padding: "10px 40px",
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          {isLoggingOut ? (
            <>
              <Spinner size="sm" style={{ marginRight: "10px" }} />
              Logging Out...
            </>
          ) : (
            <>
              <i
                className="fas fa-sign-out-alt"
                style={{ marginRight: "10px" }}
              ></i>
              Logout Now
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SessionExpirationModal;
